(function () {
  'use strict';

  angular.module(moduleConfig.applicationModuleName).factory('httpInterceptor', ['$q', '$injector', '$rootScope', '$window', 'ute.datalayer.common.service', 'dtmServiceConstants', function ($q, $injector, $rootScope, $window, dataLayerService, dtmServiceConstants) {
    var service = {};
    var self = {};
    var notifier;

    self.processSessionExpired = function(){
      var commonService = $injector.get('commonService');

      if (!commonService.loggingOut) {
        commonService.loggingOut = true;
        if ($rootScope.ruiMethods.user.is.agent()) {
          $rootScope.ruiMethods.agent.signOut('retail.message.sessionExpiredLoginAgain');
        } else {
          commonService.logOutUser(false, 'global.message.sessionExpiredLoginAgain', 'login');
        }
      }
    };

    self.triggerErrorTracking = function(response, status){
      var apiNodeArray = response.config.url.split('/');
      var apiDetails = _.takeRight(apiNodeArray, 2);
      if (_.findIndex(dtmServiceConstants.dataLayerTrack.apiErrorTracking, function(apiErrorTracking) { return apiErrorTracking.flow == apiDetails[0]; }) != -1) {
        var analyticsInfo = {
          flowName: apiDetails[0],
          apiName: apiDetails[1]
        };
        dataLayerService.trackApiError(response, analyticsInfo, status);
      }
    };

    service = {
      request: function(config) {
        if (config.url.match(/api\//)) {
          dataLayerService.trackHttpRequest(config);
        }
        return config;
      },
      response: function (response) {

        //TODO - To merge this with the 2nd if condition below for triggerErrorTracking
        if (_.get(response.config, 'track')) {
          dataLayerService.trackHttpResponse(response);
        }

        if(response && response.config && response.config.url && response.config.url.indexOf("api/selfserve") > -1) {
          if(response && response.data && !_.isEmpty(response.data.error)){
            self.triggerErrorTracking(response, true);
          }
        }

        // to avoid circular dependencies because 'brt' uses '$http'
        if (response.data.errorCode == 80001) { //Temporarily blocked feature
          notifier = notifier || $injector.get('notifier');
          notifier.notify.error(response);
        } else if (response.status === 401 || response.status === 440) {
          self.processSessionExpired();
        }
        //Added to by pass the captcha
        if(response.headers('Recaptcha-ByPass-Flag') === "true"){
          $rootScope.isByPassed = true;
        }
        return response || $q.when(response);
      },
      responseError: function (rejection) {

        //TODO - To merge this with the 2nd if condition below for triggerErrorTracking
        if (_.get(rejection.config, 'track') || rejection.config.url.match(/api\//)) {
          dataLayerService.trackHttpResponseError(rejection);
        }

        if(rejection && rejection.config && rejection.config.url && rejection.config.url.indexOf("api/selfserve") > -1) {
          self.triggerErrorTracking(rejection, false);
        }

        if (rejection.status === 401 || rejection.status === 440) {
          console.log('Response Error ' + rejection.status , rejection);

          self.processSessionExpired();
        }
        return $q.reject(rejection);
      }
    };
    return service;
  }]);
})();
